<!--MessageGuideIcon.vue-->
<!--#53091 セッション切れでvue.jsのリソースに参照できなくなった場合、
ログインセッション切れのメッセージダイアログのアイコンが読み込めない状態にまれになる。
それを解消するため、画像リンクでの表示ではなく、直接SVGの内容をコンポーネントに記載することで回避-->
<template>
    <div class="IconSize">
        <!--Error Icon-->
        <template v-if="iconType === MessageType.Error">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                <g id="a1908c24-145e-408e-856f-0d237994df40" data-bs-name="レイヤー 5">
                    <circle cx="120" cy="120" r="100" fill="#c73e38" />
                    <path d="M133.54858,120.00586l33.64551-33.65039A9.53053,9.53053,0,0,0,170,79.6001a9.67191,9.67191,0,0,0-2.80591-6.79395,9.58136,9.58136,0,0,0-13.5498,0L120,106.45508,86.35571,72.80615a9.581,9.581,0,0,0-13.5498,13.54932l33.64551,33.65039L72.80591,153.65625a9.581,9.581,0,0,0,13.5498,13.54932L120,133.55615l33.64429,33.64942a9.581,9.581,0,0,0,13.5498-13.54932Z" fill="#fff" />
                </g>
            </svg>
        </template>
        <!--warning-->
        <template v-else-if="iconType === MessageType.Warning">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                <g id="b5278ebe-7d54-48f0-b5e3-60bac60958dc" data-bs-name="レイヤー 5">
                    <path d="M217.5,177.5,138.69654,41.17667a21.22945,21.22945,0,0,0-37.4125.02916L22.5,177.5a19.67288,19.67288,0,0,0-2.5,10A22.40645,22.40645,0,0,0,42.5,210h155A22.40645,22.40645,0,0,0,220,187.5,19.70264,19.70264,0,0,0,217.5,177.5Z" fill="#fabe50"/>
                    <circle cx="120" cy="177.5" r="12.5" fill="#493712"/>
                    <path d="M128.58154,143.77917C128.21071,147.295,124.46821,150,120.00238,150c-4.47167,0-8.21417-2.705-8.58167-6.22083,0,0-3.92071-62.77917-3.92071-68.94584C107.5,67,111.46667,60,120.00238,60,128.53571,60,132.5,67,132.5,74.83333,132.5,81,128.58154,143.77917,128.58154,143.77917Z" fill="#493712"/>
                </g>
            </svg>
        </template>
        <!--info-->
        <template v-else>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                <g id="e55d3ae3-6a81-4989-920b-aa9ca8f4aa9b" data-bs-name="240x240">
                    <path d="M120,20A100,100,0,1,0,220,120,100,100,0,0,0,120,20Z" fill="#1464B9"/>
                </g>
                <g id="b43da061-7bcf-45ee-a375-515d02cfa0ff" data-bs-name="レイヤー 5">
                    <circle cx="119.5" cy="62.5" r="12.5" fill="#fff"/>
                    <rect x="107" y="90" width="25" height="100" rx="12.49999" fill="#fff"/>
                </g>
            </svg>
        </template>
    </div>
</template>
<script setup lang="ts">
    import { defineProps } from 'vue';
    import { MessageType } from '@/models/Message/MessageType';

    //メッセージの種類
    const props = defineProps<{
        iconType: number
    }>();
</script>
<style scoped>
    .IconSize {
        height: 24px;
        width: 24px;
        margin-right: 8px;
    }
</style>